export default __webpack_public_path__ + "static/Kamil_Homernik-be356b534441db8bb3901b38fac6ed53.jpeg";